import { render, staticRenderFns } from "./Kiosk.vue?vue&type=template&id=9aee2d70&scoped=true&"
import script from "./Kiosk.vue?vue&type=script&lang=js&"
export * from "./Kiosk.vue?vue&type=script&lang=js&"
import style0 from "./Kiosk.vue?vue&type=style&index=0&id=9aee2d70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aee2d70",
  null
  
)

export default component.exports